import React, { useState, useEffect } from 'react';
import NavMenu from 'components/NavMenu';
import { useStyles, styles } from './UserSearchScreenStyles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import TextEvents from 'app/components/TextEvents';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Button, Spin, Table, Tabs, Drawer } from 'antd';
import { Grid } from '@material-ui/core';
import TextInput from '../../components/TextInput';
import InternalEmployeesContainer from './InternalEmployeesContainer/InternalEmployeesContainer';
import ExternalEmployeesContainer from './ExternalEmployeesContainer/ExternalEmployeesContainer';
import KardexScreen from './KaredexScreen/KardexScreen';

const UserSearchScreen = (props) => {

    const classes = useStyles();
    const { TabPane } = Tabs;
    const [activeKey, setTabBar] = useState('1');
    const [isVisible, setVisible] = useState(false);
    const [employeeId, setEmployeeId] = useState('');
    const [isExternal, setIsExternal] = useState(false);
    const [externalUserName, setExternalUsername] = useState('');

    const handleTabChange = (tab) => {
        setTabBar(tab);
    }

    const onBack = () => {
        //dispatch(clearCommunicationProgramDetails())
        setVisible(false)
    }

    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} isCatalog={false} header='Búsqueda' isCommunicationStatus={false} />
            <CssBaseline />

            <div className={`${classes.content}`}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label="Breadcrumb">
                        <Link color="inherit" disabled>
                            Gestión
                        </Link>
                        <TextEvents
                            text="Búsqueda de Colaborador"
                            color="cotemar"
                            size='subtitle'
                            weight="bold"
                        />
                    </Breadcrumbs>

                    <Paper className={classes.rootPaper}>
                        <Tabs
                            type='card'
                            tabBarStyle={{ margin: 0 }}
                            activeKey={activeKey}
                            defaultActiveKey='1'
                            className={classes.tabContainer}
                            onChange={tab => (handleTabChange(tab))}
                        >
                            <TabPane tab='Internos' key='1'>
                                <Paper
                                    className={classes.paper}
                                    key='1'
                                >
                                    <InternalEmployeesContainer
                                        showKardex={setVisible}
                                        isVisibleKardex={isVisible}
                                        setEmployeeId={setEmployeeId}
                                        setIsExternal={setIsExternal}
                                        size={"small"}
                                    />
                                </Paper>
                            </TabPane>

                            <TabPane tab='Externos' key='2' className={classes.tab}>
                                <Paper
                                    className={classes.paper}
                                    key='2'
                                >
                                    <ExternalEmployeesContainer
                                        showKardex={setVisible}
                                        isVisibleKardex={isVisible}
                                        setEmployeeId={setEmployeeId}
                                        setIsExternal={setIsExternal}
                                        setExternalUsername={setExternalUsername}
                                        size={"small"}
                                    />
                                </Paper>
                            </TabPane>
                        </Tabs>
                        {/* <Spin spinning={true}>
                            <Grid container direction="row">
                                <Grid item xs={12}>
                                </Grid>
                            </Grid>
                        </Spin> */}
                    </Paper>
                </div>
            </div>
            <Drawer
                title={<div className={classes.headerDrawer}><Button onClick={onBack} type='link' icon='left'>Regresar </Button><TextEvents
                    text={'CotPlay'}
                    color='dark'
                    size='label'
                    weight='bold'
                /></div>}
                width={'100%'}
                closable={false}
                onClose={() => setVisible(false)}
                visible={isVisible}
                destroyOnClose={true}
            >
                <KardexScreen
                    employeeId={employeeId}
                    isExternal={isExternal}
                    externalUserName={externalUserName}
                />
            </Drawer>
        </div>
    )
}

export default UserSearchScreen;